module.exports = __webpack_public_path__ + "static/media/back-arrow.835aa6e4.svg";